// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// app modules: components
import Link from 'components/Link';
import Image from 'components/Image';

// app modules: props
import AuthorsProps from 'components/Authors/AuthorsProps';

// app modules: services
import assets from 'services/assets';
import route from 'services/route';

// assets
import CssThumbnailItem from './ThumbnailItem.scss';

class SearchAuthorItem extends PureComponent {
  static propTypes = {
    item: AuthorsProps.author.isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  render() {
    const { item, onClick } = this.props;

    return (
      <div className="search-thumbnail-item">
        <Link to={route.person(item.id, item.is_author)} onClick={onClick}>
          <Image
            shape="circle"
            image={assets.avatarUrl(item.avatar_name, {
              resize: 'fit-in',
              width: 200,
              height: 200,
            })}
            height={94}
          />
          <h4 className="searchResults__author-name">
            {item.first_name} {item.last_name}
          </h4>
        </Link>
      </div>
    );
  }
}

export default withStyles(CssThumbnailItem)(SearchAuthorItem);
